const handlise = (string) => {
	return string.toLowerCase().normalize("NFD").replace(/\p{Diacritic}/gu, "").replace(/[^a-z0-9]+/g, '-');
}

class ARButton extends HTMLElement {
	static get observedAttributes() {
		return ['items'];
	}

	attributeChangedCallback(name, oldValue, newValue) {
		if (name === 'items') {
			this.items = JSON.parse(newValue);

			if (this.items.length < 5 || !this.items.every(item => item.Colour)) this.style.display = 'none';
			else if (this.items.some(item => item.Type == 'Standard Pillowcase' && item.Colour.includes('Scalloped'))) this.style.display = 'none';
			else this.style.display = '';
		}
	}

	constructor() {
		super();
		this.key = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJ2aXN1YWxpc2FyLWFwaS11c2VyIiwiaWF0IjoxNjg0ODc3MjE4LCJlbnYiOiJwcmUtcHJvZCJ9.lq_vO3DfkH0mjxwhvnhZYW2oXHgpO7Ubi-XOWLcrYuk';

		this.addEventListener('click', async e => {
			this.classList.add('show-loading');

			let url = null;

			if (this.getAttribute('shortlink')) {
				url = `https://webar.viewa.com/bed-threads-bundles?bt=${this.getAttribute('shortlink')}`;
			}
			else {
				const shortlink = await this.getShortlink();
				url = `https://webar.viewa.com/bed-threads?bt=${shortlink}`;
			}

			if (url != null) {
				window.location.href = `https://bedthreads.com.au/?view=ar-callback&url=${encodeURIComponent(url)}&host=${encodeURIComponent(window.location.host)}`
			}
		});
	}

	async getShortlink() {
		const items = this.items;

		const duvet = items.find(item => item.Type === 'Duvet Cover');
		const fittedSheet = items.find(item => item.Type.includes('Fitted Sheet'));
		const flatSheet = items.find(item => item.Type.includes('Flat Sheet'));
		const standardPillow1 = items.find(item => item.Type.includes('Pillowcase') && !item.Type.includes('European'));
		const pillow2 = items.find(item => item.Type.includes('Pillowcase') && item != standardPillow1);

		const euroPillow = pillow2.Type.includes('European') ? pillow2 : null;
		const standardPillow2 = !pillow2.Type.includes('European') ? pillow2 : null;

		let euroColour = null;
		let scallopedColour = null;

		if (euroPillow) {
			if (euroPillow.Colour.includes('Scalloped')) {
				[euroColour, scallopedColour] = euroPillow.Colour.replace('Scalloped', '').split('&').map(c => handlise(c.trim()));
			}
			else euroColour = handlise(euroPillow.Colour);
		}

		const arData =  {
			clientStub: "bed-threads",
			version: 1,
			modelId: "bt-combinedbed-23",
			materialIds: [
				handlise(duvet.Colour), // Duvet cover
				handlise(fittedSheet.Colour), // Fitted sheet
				flatSheet ? handlise(flatSheet.Colour) : 'none', // Flat sheet
				handlise(standardPillow1.Colour), // First/standard pillowcase
				euroColour ? euroColour : 'none', // European pillowcase (inner colour for scalloped)
				scallopedColour ? scallopedColour : 'none', // Scalloped Euro outer colour
				standardPillow2 ? handlise(standardPillow2.Colour) : 'none' // Second standard pillowcase
			],
			additionalData: {
				items: JSON.stringify(items)
			}
		};

		const resp = await fetch('https://api.viewa.com/api/webar/hotlink/', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': `Bearer ${this.key}`
			},
			body: JSON.stringify(arData)
		});

		this.classList.remove('show-loading');

		if (resp.ok) {
			const json = await resp.json();
			const shortLink = json.shortLink;
			return shortLink;
		}
	}
}

customElements.define('ar-button', ARButton);